import React, { Component } from "react";

interface McpChatErrorBoundaryProps {
  children: React.ReactNode;
}

interface McpChatErrorBoundaryState {
  hasError: boolean;
}

// Error boundaries must be class components (React limitation).
class ErrorBoundaryClass extends Component<McpChatErrorBoundaryProps, McpChatErrorBoundaryState> {
  state: McpChatErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): McpChatErrorBoundaryState {
    return { hasError: true };
  }

  render(): React.ReactElement | null {
    if (this.state.hasError) {
      return (
        <div className="mcp-chat__bubble mcp-chat__bubble--error" style={{ fontSize: 12, opacity: 0.7 }}>
          Could not render this message.
        </div>
      );
    }
    return this.props.children as React.ReactElement;
  }
}

// Wrapped via createElement to avoid TS2786 from conflicting @types/react
// (hoist-non-react-statics ships its own copy).
const McpChatErrorBoundary: React.FC<McpChatErrorBoundaryProps> = ({ children }) => {
  return React.createElement(ErrorBoundaryClass as any, null, children);
};

export default McpChatErrorBoundary;
